import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { User } from '@recruitee/account-types';
import { I18nService } from '@recruitee/i18n';
import { AdminsAvatarsComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-candidate-profile-page-online-admins-indicators',
  templateUrl: './online-admins-indicators.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdminsAvatarsComponent],
})
export class CandidateProfilePageOnlineAdminsIndicatorsComponent {
  @Input() public admins: User[];

  constructor(private i18n: I18nService) {
    this.renderAdminTooltip = this.renderAdminTooltip.bind(this);
    this.renderOtherAdminsTooltip = this.renderOtherAdminsTooltip.bind(this);
  }

  public renderAdminTooltip(admin: User): string {
    return this.i18n.translate('app.candidate.online_admins_indicators.admin_tooltip', {
      adminName: [admin.firstName, admin.lastName].filter(Boolean).join(' '),
    });
  }

  public renderOtherAdminsTooltip(admins: User[]): string {
    return this.i18n.translate('app.candidate.online_admins_indicators.other_admins_tooltip', {
      adminsCount: admins.length,
      adminsNames: admins
        .map(admin => [admin.firstName, admin.lastName].filter(Boolean).join('&nbsp'))
        .join(', '),
    });
  }
}
